import type { Tokens } from '../../../../theming/types'
import type { SelectionControlGroupProps } from '..'

export default (config: {
  props: Pick<SelectionControlGroupProps, 'description' | 'isFeedbackLegend'>
  tokens: Tokens
}) => {
  const { props, tokens } = config
  return {
    default: {
      fieldset: {
        '& > &, .selectionControlGroupNestedWrap': {
          marginInlineStart: tokens.spacingGap400,
        },

        '.selectionControlGroupItemBottomMargin': {
          marginBlockEnd: tokens.spacingGap100,
        },
      },

      legend: {
        ...(props.isFeedbackLegend ? tokens.fontBodyS : tokens.fontLabel),
        marginBlockEnd: !props.description ? tokens.spacingGap50 : undefined,
      },
    },
  } as const
}
